import { useEffect, useState } from "react";
import api from "../lib/api";

const SettingsContext = { whatsapp: "+33 7 46 34 42 06", phone: "+33 7 46 34 42 06", email: "groznylocation@gmail.com" };

export function useSettings() {
  const [settings, setSettings] = useState(SettingsContext);
  useEffect(() => {
    api
      .get("/settings/public")
      .then(({ data }) => setSettings(data))
      .catch(() => {});
  }, []);
  return settings;
}

export function waLink(whatsapp, text) {
  const num = (whatsapp || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(text || "")}`;
}
